package de.oevbs.kunde.kundenportal2.services.claims

import de.oevbs.businesspartner.bpcrmservice2.claim.model.Claim
import de.oevbs.businesspartner.bpcrmservice2.claim.model.ClaimStatus
import de.oevbs.businesspartner.bpcrmservice2.common.model.LineOfBusiness
import de.oevbs.kosmos.ui.icons.Icon
import de.oevbs.kosmos.ui.icons.LineOfBusinessIcons
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kosmos.ui.overlays.tooltip.tooltip
import de.oevbs.kunde.kundenportal2.Pages.claimList
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.sfa.data.time.toLocalizedString
import dev.fritz2.core.RenderContext
import kotlinx.coroutines.flow.combine

fun RenderContext.subPageClaimList() {
    headerImageLayout {
        title(claimList.linkTitle)
        content {
            contentContainer {
                ClaimsStore.loadClaims(Unit)

                globalInitTracker.data.combine(ClaimsStore.initFailedFlow, ::Pair).render { (loading, failed) ->
                    if (loading) return@render
                    when {
                        failed -> noPartnerDataFoundMessage()
                        else -> {
                            if (ClaimsStore.current.isEmpty()) noPartnerDataFoundMessage(
                                """Danke fürs Vorbeischauen! Wie es aussieht, sind Sie gerade schadenfrei 
                                    | oder Ihr Schaden ist noch nicht im System erfasst.""".trimMargin()
                            )
                            else renderClaimsCollapsibles()
                        }
                    }
                }
            }
        }
    }
}

private fun RenderContext.renderClaimsCollapsibles() {
    ClaimsStore.data.renderEach(Claim::_id) { claim ->
        collapsible {
            isRead(true)
            headerLeft(claim.kindOfEvent, iconOfClaim(claim)).also {
                className(colorOfClaimIcon(claim))
                tooltip(
                    text = when (claim.status) {
                        ClaimStatus.Offen -> "Schaden wird bearbeitet."
                        ClaimStatus.Geschlossen -> "Schaden ist abgeschlossen."
                        else -> "Schaden-Status unbekannt"
                    }
                )
            }

            headerRight("SchadenNr. ${claim.claimNumber}", MaterialIconsOutlined.water_damage)
            if (claim.lineOfBusiness != LineOfBusiness.Unbekannt) headerRight(
                claim.lineOfBusiness.title,
                LineOfBusinessIcons.valueOf(claim.lineOfBusiness.value)
            )
            if (claim.contractNumber.isNotBlank()) headerRight(
                "VNr.  ${claim.contractNumber}",
                MaterialIconsOutlined.book_2
            )

            content {
                detailsGrid {
                    detailsGridEntry("Status", claim.status.value)
                    detailsGridEntry(
                        "Schadentag",
                        claim.dateOfAccident?.toLocalizedString() ?: "unbekannt"
                    )
                    if (claim.clerk.isNotBlank()) detailsGridEntry(
                        "Bearbeiter",
                        claim.clerk
                    )
                    detailsGridEntry(
                        "Meldetag",
                        claim.dateOfNotification?.toLocalizedString() ?: "unbekannt"
                    )
                    detailsGridEntry(
                        "Sparte",
                        if (claim.branchGroup.isNotBlank()) "${claim.lineOfBusiness.value} (${claim.branchGroup})"
                        else claim.lineOfBusiness.value
                    )
                    detailsGridEntry("Grund", claim.claimReason)
                    if (claim.lineOfBusiness == LineOfBusiness.Sach) {
                        detailsGridEntry("Hauptschaden", claim.mainClaim)
                        detailsGridEntry("Schadentyp", claim.claimType)
                        detailsGridEntry("Ort", claim.riskCity)
                        detailsGridEntry("Straße", claim.riskStreet)
                        detailsGridEntry("Versichertes Risiko", claim.insuredRisk)
                    } else if (claim.lineOfBusiness == LineOfBusiness.Kfz) {
                        detailsGridEntry("Kennzeichen", claim.licensePlate)
                    }
                }
            }
        }
    }
}

private fun iconOfClaim(claim: Claim): Icon = when (claim.status) {
    ClaimStatus.Offen -> MaterialIconsOutlined.hourglass_empty
    ClaimStatus.Wiedereroeffnet -> MaterialIconsOutlined.hourglass_empty
    ClaimStatus.Geschlossen -> MaterialIconsOutlined.check_circle
    ClaimStatus.GeschlossenNachWiedereroeffnet -> MaterialIconsOutlined.check_circle
    else -> MaterialIconsOutlined.error
}

private fun colorOfClaimIcon(claim: Claim): String = when (claim.status) {
    ClaimStatus.Offen -> "text-info-500"
    ClaimStatus.Wiedereroeffnet -> "text-info-500"
    ClaimStatus.Geschlossen -> "text-success-500"
    ClaimStatus.GeschlossenNachWiedereroeffnet -> "text-success-500"
    else -> "text-error-500"
}